import * as yup from 'yup'

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/

export const shiftSchema = yup.object({
	am: yup.object({
		halls: yup
			.array()
			.of(
				yup.object({
					milk_hall: yup.string().required('Введите данные'),
					start: yup
						.string()
						.matches(timeRegex, 'Введите время')
						.required('Введите данные'),
					end: yup
						.string()
						.matches(timeRegex, 'Введите время')
						.required('Введите данные'),
				}),
			)
			.required(),
	}),
	pm: yup.object({
		halls: yup
			.array()
			.of(
				yup.object({
					milk_hall: yup.string().required('Введите данные'),
					start: yup
						.string()
						.matches(timeRegex, 'Введите время')
						.required('Введите данные'),
					end: yup
						.string()
						.matches(timeRegex, 'Введите время')
						.required('Введите данные'),
				}),
			)
			.required(),
	}),
	night: yup.object({
		halls: yup
			.array()
			.of(
				yup.object({
					milk_hall: yup.string().required('Введите данные'),
					start: yup
						.string()
						.matches(timeRegex, 'Введите время')
						.required('Введите данные'),
					end: yup
						.string()
						.matches(timeRegex, 'Введите время')
						.required('Введите данные'),
				}),
			)
			.required(),
	}),
	am_allowed_deviation_seconds: yup
		.string()
		.matches(/^\d+$/, 'Введите целое число')
		.required('Введите данные')
		.defined(),
	pm_allowed_deviation_seconds: yup
		.string()
		.matches(/^\d+$/, 'Введите целое число')
		.required('Введите данные')
		.defined(),
	night_allowed_deviation_seconds: yup
		.string()
		.matches(/^\d+$/, 'Введите целое число')
		.required('Введите данные')
		.defined(),
})
